/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Awaiting_Run_Approval_ComposerInputs */



/**
* | output |
* | --- |
* | "Waiting for approval of the agent run" |
*
* @param {Chat_Awaiting_Run_Approval_ComposerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_awaiting_run_approval_composer = /** @type {((inputs?: Chat_Awaiting_Run_Approval_ComposerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Awaiting_Run_Approval_ComposerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wartet auf die Freigabe des Agentenlaufs")
	return /** @type {LocalizedString} */ ("Waiting for approval of the agent run")
});